"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var sessionRevokedException = 'com.unitedtraders.luna.platform2.security.server.exception.SessionRevokedException';
var cancelSubscriptionOnLogoutException = 'com.unitedtraders.luna.platform2.web.exceptions.CancelSubscriptionOnLogoutException';
var BaseService = (function () {
    function BaseService(clients, logger, schema, options) {
        this.clientName = 'BaseService';
        this.logger = logger;
        this.clients = clients;
        if (options.config) {
            var actualOptions = options;
            this.config = actualOptions.config;
            this.removeTokens = actualOptions.removeTokens;
        }
        else {
            var config = options;
            this.config = config;
        }
    }
    BaseService.prototype.createRest = function (name, isAuthorized, requestSchema, responseSchema, fancyName) {
        var _this = this;
        return function (request, metadata, options) {
            var client = isAuthorized ? _this.clients.securedRest : _this.clients.rest;
            _this.logger.debug(fancyName + ": Request:", request);
            var response = client.send(name, request, metadata);
            return response
                .then(function (data) {
                _this.logger.debug(fancyName + ": Response:", data.data);
                return data;
            })
                .catch(function (error) {
                var _a, _b, _c, _d;
                var responseBody = typeof ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === 'object'
                    ? JSON.stringify((_b = error.response) === null || _b === void 0 ? void 0 : _b.data)
                    : (_c = error.response) === null || _c === void 0 ? void 0 : _c.data;
                var requestBody = typeof request === 'object' ? JSON.stringify(request) : request;
                var msg = fancyName + ": Error in request to url=" + name + ", response status=" + ((_d = error.response) === null || _d === void 0 ? void 0 : _d.status) + ", " +
                    ("response body=" + responseBody + ", ") +
                    ("request=" + requestBody + ", error message=" + error.message);
                _this.logger.debug(msg);
                throw error;
            });
        };
    };
    BaseService.prototype.createStream = function (name, isAuthorized, requestSchema, responseSchema, fancyName) {
        var _this = this;
        return function (request, metadata, options) {
            _this.logger.debug(fancyName + ": Subscribe:", request);
            return _this.clients
                .stream.topic({
                parameters: request,
                name: name,
                metadata: metadata,
                isAuthorized: isAuthorized,
                isRaw: options && options.isRaw
            })
                .pipe(operators_1.tap(function (data) {
                _this.logger.debug(fancyName + ": Response:", data);
            }), operators_1.catchError(function (error) {
                var _a;
                if (error.type === sessionRevokedException ||
                    error.type === cancelSubscriptionOnLogoutException) {
                    (_a = _this.removeTokens) === null || _a === void 0 ? void 0 : _a.call(_this);
                }
                throw error;
            }));
        };
    };
    return BaseService;
}());
exports.BaseService = BaseService;
//# sourceMappingURL=BaseService.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@utex/base-api-sdk/dist/BaseService.js
// module id = 1635
// module chunks = 118